import { FunctionComponent, useEffect, useState } from 'react'
import DashboardItem from '../DashboardItem'
import { getMemberApplications } from 'Frontend/scripts/services/membershipApplication.service'
import { IUserApplication } from 'Frontend/scripts/models/user.model'
import ApplicationItem from './ApplicationItem'
import { useTranslation } from 'react-i18next'

const HandleMembershipApplications: FunctionComponent = () => {
  const [applications, setApplications] = useState<IUserApplication[]>()
  const { t } = useTranslation()

  const getAllApplications = () => {
    getMemberApplications().then((applications) => {
      setApplications(applications)
    })
  }

  useEffect(() => {
    getAllApplications()
  }, [])
  return (
    <DashboardItem heading={t('member-applications')}>
      {applications?.map((applicant: IUserApplication) => (
        <ApplicationItem key={`applicant${applicant.id}`} applicant={applicant} callback={() => getAllApplications()} />
      ))}
    </DashboardItem>
  )
}

export default HandleMembershipApplications
